module.exports = __webpack_public_path__ + "img/8.09e7deff.jpg";